import React, { useState } from "react";

function App() {

    const [color,setColor] = useState()

    const handleColor = ()=>{
        setColor(prev => !prev)
    }

  return (
    <div
      style={{
        height: "100vh",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        backgroundColor: color ? "white" : "black",
        transition: "background-color 0.5s ease"
      }}
    >
      <button className="btn btn-success" onClick={handleColor}>Switch Theme</button>
    </div>
  );
}
export default App;